
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recurring-payments",
      function () {
        return require("private-next-pages/recurring-payments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recurring-payments"])
      });
    }
  